import { lazy } from "react";
import Loadable from "components/Loadable";

const DashboardDefault = Loadable(lazy(() => import("pages/dashboard/default")));
const AssistantPage = Loadable(lazy(() => import("pages/assistant/AssistantPage")));
const AssistantPageAddEdit = Loadable(lazy(() => import("pages/assistant/AssistantPageAddEdit")));
const AssistantDemo = Loadable(lazy(() => import("pages/assistant/AssistantDemo")));

const privateRoutes = [
	{ path: "/dashboard", name: "Dashboard", element: <DashboardDefault /> },

	{ path: "/assistant", name: "Assitance", element: <AssistantPage /> },
	{ path: "/assistant/add", name: "Assitance", element: <AssistantPageAddEdit /> },
	{ path: "/assistant/:id/edit", name: "Assitance", element: <AssistantPageAddEdit /> },
	{ path: "/assistant/:id/demo", name: "Assitance", element: <AssistantDemo /> },

	// 🔥 KEEP ALL YOUR ROUTES AS-IS
];

export default privateRoutes;
